
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';
import * as VM from '@/viewModel';
import { Prop, Watch } from 'vue-property-decorator';

@Options({
    components: {
    }
})
export default class TableFilter extends Vue {

    @Prop() pagedRequest: OM.PagedRequestVM;
    @Prop() totalItems: number;

    localPagedRequest: OM.PagedRequestVM = new OM.PagedRequestVM();
    pages: number[] = [];
    lowerPages: number = 0;
    upperPages: number = 0;

    @Watch("totalItems")
    @Watch("pagedRequest", { deep: true})
    requestChanged(){
        this.localPagedRequest = this.pagedRequest;
        this.calcPagination();
    }

    get totalPages(){
        return Math.ceil((this.totalItems) / this.localPagedRequest.paging.itemsPerPage);
    }
    get selectedPage(){
        return this.localPagedRequest.paging.currentPage;
    }

    created(){
        this.localPagedRequest = this.pagedRequest;
        this.calcPagination();
    }

    subtractPage(){
        if(this.selectedPage > 1){
            var vm = this.localPagedRequest;
            vm.paging.currentPage--;
            this.$emit("update:pagedRequest", vm);
            this.calcPagination();
        }
    }
    addPage(){
        if(this.selectedPage < this.totalPages){
            var vm = this.localPagedRequest;
            vm.paging.currentPage++;
            this.$emit("update:pagedRequest", vm);
            this.calcPagination();
        }
    }

    setSelectedPage(index: number){
        var vm = this.localPagedRequest;
        vm.paging.currentPage = index;
        this.$emit("update:pagedRequest", vm);
    }

    calcPagination(){
        this.lowerPages = this.selectedPage - 2;
        this.upperPages = this.selectedPage + 2;

        if(this.selectedPage == 1)
            this.upperPages += 2;
        else if(this.selectedPage == 2)
            this.upperPages += 1;

        if(this.selectedPage == this.totalPages)
            this.lowerPages -= 2;
        else if(this.selectedPage == this.totalPages - 1)
            this.lowerPages -= 1;

        if(this.upperPages > this.totalPages)
            this.upperPages = this.totalPages;

        if(this.lowerPages <= 0)
            this.lowerPages = 1;

        if(this.upperPages <= 0)
            this.upperPages = 1;
            
        this.pages = [];
        for(let i = this.lowerPages; i <= this.upperPages; i++){
            this.pages.push(i);
        }
    }

    changePage(){
        this.localPagedRequest.paging.currentPage = 1;
        this.$emit('update:pagedRequest', this.localPagedRequest)
    }
}
